import Blue from "~/core";

new Blue({
  name: "Header Cleanup",
  selector: ".header",
  setup(header) {
    const items = header.querySelectorAll(".header__menu, .drawer");
    const cleanup = () => {
      items.forEach(i => {
        i.classList.remove("drawer--active");
        i.classList.remove("drawer--active-sub");
        i.classList.remove("header__menu--active");
      });
      this.$scrollLock.clear();
    };

    this.$screen.xl.addListener(cleanup);

    this.$addEvents(header, "focusout", () => {
      if (
        !header.matches(":focus-within") &&
        !document.body.classList.contains("using-mouse")
      )
        cleanup();
    });
  }
});

new Blue({
  name: "Header Retach",
  selector: ".header",
  setup(header) {
    const drawer_menu = header.querySelector(".drawer__menu");
    const nav_items = header.querySelectorAll(".nav__item");
    const util_items = header.querySelectorAll(".util__item");

    const config = {
      destination: drawer_menu,
      mediaQuery: 1049,
      movedClass: "drawer__item"
    };

    this.$retach(nav_items, config);
    this.$retach(util_items, config);
  }
});

new Blue({
  name: "Header Mobile",
  selector: ".header",
  setup(header) {
    const toggle = header.querySelector(".toggle");
    const drawer = header.querySelector(".drawer");
    const inner = drawer.querySelector(".drawer__inner");
    const title = drawer.querySelector(".drawer__title span:last-child");
    const close = drawer.querySelector(".drawer__close");
    const back = drawer.querySelector(".drawer__back");

    const triggers = header.querySelectorAll(".nav__trigger");
    const _this = this;

    const open_menu = () => {
      drawer.classList.add("drawer--active");
      this.$scrollLock.lock(inner);
    };
    const close_menu = () => {
      drawer.classList.remove("drawer--active");
      drawer.classList.remove("drawer--active-sub");
      drawer
        .querySelectorAll(".header__menu--active")
        .forEach(a => a.classList.remove("header__menu--active"));
      this.$scrollLock.clear();
    };
    const forward_sub = function() {
      _this.$scrollLock.clear();
      _this.$scrollLock.lock(this.nextElementSibling);
      inner.scrollTop = 0;
      title.textContent = this.textContent;
      drawer.classList.add("drawer--active-sub");
    };
    const back_sub = () => {
      _this.$scrollLock.clear();
      _this.$scrollLock.lock(inner);
      drawer.classList.remove("drawer--active-sub");
      drawer
        .querySelectorAll(".header__menu--active")
        .forEach(a => a.classList.remove("header__menu--active"));
    };

    this.$addEvents(toggle, "click enter", open_menu);
    this.$addEvents(close, "click enter", close_menu);

    this.$addEvents(triggers, "click enter", forward_sub);
    this.$addEvents(back, "click enter", back_sub);
  }
});

new Blue({
  name: "Nav Toggles",
  selector: ".nav__trigger, .action__trigger, .action__close, .search__trigger",
  setup(trigger) {
    const header = trigger.closest(".header");
    const header_inner = header.querySelector(".header__inner");
    const item = trigger.closest(".header__menu");
    const sub = item.querySelector(
      ".nav__sub-item, .action__menu, .search__inner"
    );

    const toggle = () => {
      const sibs = [...header.querySelectorAll(".header__menu--active")].filter(
        s => s !== item
      );
      
      item.classList.toggle("header__menu--active");
      sibs.forEach(s => s.classList.remove("header__menu--active"));
      
      if (item.classList.contains("header__menu--active")) {
        const menu = item.querySelector(".nav__sub, .action__menu") || false;
        if(item.classList.contains('search')) {
          const searchInput = item.querySelector('.search__input')
          const searchInner = item.querySelector('.search__inner')
          searchInner.addEventListener('transitionend', (evt) => {
            if(evt.propertyName === 'opacity') {
              searchInput.focus()
            }
          })
        }
        if (!this.$screen.xl.matches) {
          this.$scrollLock.lock(sub);
          if (menu) {
            menu.style.marginLeft = "";
            menu.style.marginRight = "";
          }
        } else {
          if (menu) {
            let header_rect = header_inner.getBoundingClientRect();
            let rect = menu.getBoundingClientRect();

            if (rect.left < header_rect.left) {
              menu.style.marginLeft = `${Math.ceil(
                Math.abs(rect.left - header_rect.left)
              )}px`;
            } else if (rect.right > header_rect.right) {
              menu.style.marginLeft = `-${Math.ceil(
                Math.abs(rect.right - header_rect.right)
              )}px`;
            }
          }
        }
      } else {
        this.$scrollLock.unlock(sub);
        if (this.$screen.xl.matches) {
          this.$scrollLock.clear();
        }
      }
    };

    this.$addEvents(trigger, "click.prevent enter.prevent", toggle);
  }
});

new Blue({
  name: "Search Form",
  selector: "form.search.header__menu",
  setup(form) {
		const input = form.querySelector("input.search__input");
		const submit = form.querySelector("button.search__submit");

		const submitForm = (event) => {
			event.preventDefault();
			let queryString = input.value == "" ? "" : "?q=" + encodeURIComponent(input.value);
			let searchPage = input.getAttribute("data-submit-page") || "search";
			let newUrl = location.origin;

			// Removed as part of CHSS-105 to fix search dropdown functionality
			// location.href = newUrl + "/" + searchPage + queryString;

			location.replace(newUrl + "/" + searchPage + queryString);

			// Removed as part of CHSS-105 to fix search dropdown functionality
			// setTimeout(() => {
			// 	location.reload();
			// }, 1000);
		}

		this.$addEvents(form, 'submit.prevent', (e) => {submitForm(e)});
		this.$addEvents(submit, 'click.prevent', (e) => {submitForm(e)});
  }
});
